export default "__VITE_ASSET__DJC_tW2S__"